import React, { Fragment } from 'react';
import { Element } from 'react-scroll'
import About from '../../components/about/about';
import BackToTop from '../../components/backToTop/backToTop';
import Navbar from '../../components/Navbar/Navbar';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Footer from '../../components/footer/Footer';

const HomePage = () => {
    return (
        <Fragment>
            <Navbar />
            <Element name='about'>
                <About />
            </Element>
            <Element name='project'>
                <ProjectSection />
            </Element>
            <Element name='blog'>
                <BlogSection />
            </Element>
            <Footer />
            <BackToTop />
        </Fragment>
    )
};

export default HomePage;